import { render, staticRenderFns } from "./Request-Training-Submitted.vue?vue&type=template&id=60cb495a&scoped=true&"
import script from "./Request-Training-Submitted.vue?vue&type=script&lang=js&"
export * from "./Request-Training-Submitted.vue?vue&type=script&lang=js&"
import style0 from "./Request-Training-Submitted.vue?vue&type=style&index=0&id=60cb495a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cb495a",
  null
  
)

export default component.exports